import { LOG_FROM_CRM } from '../constants/graphql'
import apolloClient from '../apolloClient'

const log = {
  install (Vue, options) {
    function Log() {}
    
    /**
     * Как бы приватный метод, вызывать напрямую не рекомендуется.
     * Отправляет сообщение лога в БД.
     * 
     * @param {string} message сообщение лога
     * @param {string} category категория
     * @param {string} level уровень
     */
    Log.prototype._log = function (message, category, level) {
      const userControl = Vue.prototype.$userControl
      apolloClient.mutate({
        mutation: LOG_FROM_CRM,
        variables: {
          message: JSON.stringify({ message: message, role: userControl.jwtParsed.role }, null, 2),
          category: category,
          level: level,
          userId: userControl.jwtParsed.user_id
        }
      })
    }
    
    Log.prototype.error = function (message, category) {
      this._log(message, category, 'error');
    }
    Log.prototype.warning = function (message, category) {
      this._log(message, category, 'warning');
    }
    Log.prototype.info = function (message, category) {
      this._log(message, category, 'info');
    }
    Log.prototype.trace = function (message, category) {
      let msg = message;
      
      // поскольку код приложения при сборке минифицируется, стек не показателен, но мало ли...
      const err = new Error(message)
      if (err.stack) {
        msg = msg + "\n\nTrace:\n" + err.stack
      }
      
      this._log(msg, category, 'trace');
    }
    Log.prototype.profile = function (message, category) {
      this._log(message, category, 'profile');
    }
    
    Vue.prototype.$log = new Log()
  }
}

export default log



// WEBPACK FOOTER //
// ./src/plugins/log.js